var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-editor',{staticClass:"ma-2",attrs:{"id":"minutesEditor","placeholder":"Texte à afficher"},on:{"input":function($event){return _vm.saveModule()}},model:{value:(_vm.module.content.text),callback:function ($$v) {_vm.$set(_vm.module.content, "text", $$v)},expression:"module.content.text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }